import { Route, Routes } from "react-router-dom";
import Layout from "./Layout.js";
import AboutUs from "./components/About.js";
import Cart from "./components/Cart.js";
import ContactUs from "./components/Contact.js";
import HeroSlider from "./components/HeroSlider.js";
import Perfumes from "./components/Perfumes.js";
import Profile from "./components/Profile.js";
import Signin from "./info/Signin.js";
import Signup from "./info/Signup.js";
import ForgotPassword from "./info/ForgotPassword.js";
import AdminLogin from "./components/AdminLogin.js";
import AdminSignup from "./components/AdminSignup.js";
import AdminDashboard from "./components/AdminDashboard.js";
import Checkout from "./components/Checkout.js";
import OrderSuccess from "./components/OrderSuccess.js";
import MyOrders from "./components/MyOrders.js";
import PlacedOrders from "./components/PlacedOrders.js";
import CompletedOrders from "./components/CompletedOrders.js";
import AddressPage from "./components/AddressPage.js";
import ProductDetailPage from "./components/ProductDetailPage.js";

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HeroSlider />} />
        <Route path="/perfumes" element={<Perfumes />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/order-success" element={<OrderSuccess />} />
        <Route path="/my-orders" element={<MyOrders />} />
        <Route path="/placed-orders" element={<PlacedOrders />} />
        <Route path="/completed-orders" element={<CompletedOrders />} />
        <Route path="/addresses" element={<AddressPage />} />
        <Route path="/product/:id" element={<ProductDetailPage />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/signin" element={<Signin />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/About" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/signup" element={<AdminSignup />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
      </Route>
    </Routes>
  );
};

export default App;
